import React from 'react';
import { AccountFormWrap, Card, Container, FormContent, FormH1, FormH2, LinkButton } from './AccountElements';

const AccountOverview = ({ accountDetails }) => {
    return (
        <Card>
            <FormH1>Account Details</FormH1>
            <FormH2>Email</FormH2>
            <FormContent>{accountDetails.email}</FormContent>
            <LinkButton to={'/signin'}>Sign Out</LinkButton>
        </Card>
    );
};

export default AccountOverview;
